
export const API_STATUS = "API_STATUS";
export const CLEAR_API_STATUS="CLEAR_API_STATUS"
export const PDF_AND_PAGE_DETAILS = "PDF_AND_PAGE_DETAILS";
export const GET_MAPPING_DATA = "GET_MAPPING_DATA";
export const VALIDATE_USER_STATUS = "VALIDATE_USER_STATUS";
export const IS_SIGNATURE_UPLOADED_STATUS = "IS_SIGNATURE_UPLOADED_STATUS";
export const UPDATE_FILTER = "UPDATE_FILTER";